import React from "react";
import { ActualVsExtendedChart } from "./components/actual-vs-extended-chart";
import MonthlySlippageList from "./components/monthly-slippage-list";

export default function BillablesSlippageReports() {
  return (
    <div className="flex-1 flex flex-col overflow-auto">
      <ActualVsExtendedChart />
      <MonthlySlippageList />
    </div>
  );
}
